import { Box, CollapsibleCard } from '@atgfr8/atg-ui-tailwind';
import { FileUpload, Notification } from '@components';
import { DocumentEntityType } from '@components/FileUpload';
import { useParams } from '@solidjs/router';
import {
  fetchDocuments,
  orderDocumentStore,
  orderStore,
  resetOrderDocumentStore,
  setDocuments,
} from '@store/orders';
import type { ChangeTrackingSource } from '@typeDefinitions/changeTrackingTypes';
import { createEffect, onMount } from 'solid-js';

export type CustomerUploadFileProps = {
  deleteChangeTrackingSource?: ChangeTrackingSource;
  documentEntityType: DocumentEntityType;
  entityId: number;
  uploadChangeTrackingSource?: ChangeTrackingSource;
};

export const CustomerFileUpload = (props: CustomerUploadFileProps) => {
  const params = useParams();

  onMount(async () => {
    resetOrderDocumentStore();
    await fetchDocuments(params.id as string);
  });

  createEffect(async () => {
    if (
      Number(params.id) !== orderStore.order.id &&
      orderStore.order.id !== 0
    ) {
      resetOrderDocumentStore();
      await fetchDocuments(params.id as string);
    }
  });

  return (
    <CollapsibleCard
      startTitle="Upload Documents"
      loading={orderStore.loading}
      class="mb-2"
    >
      <Box mb="10px">
        <Notification
          type="warning"
          text={
            <Box>
              Uploading documents here will not trigger processing. Please email
              paperwork to{' '}
              <a href="mailto:AP@armstrongtransport.com">
                AP@armstrongtransport.com
              </a>{' '}
              with the load number in the subject
            </Box>
          }
          cleared={false}
        />
      </Box>
      <FileUpload
        height={45}
        deleteChangeTrackingSource={props.deleteChangeTrackingSource}
        uploadChangeTrackingSource={props.uploadChangeTrackingSource}
        alreadyUploadedDocuments={orderDocumentStore.documents}
        {...props}
        onChange={(files) => {
          setDocuments(files.map((f) => f.document));
        }}
      />
    </CollapsibleCard>
  );
};
